module.exports = __webpack_public_path__ + "img/avatar.5a44fd99.jpg";